module.exports = __webpack_public_path__ + "static/Grupo 77-92e52139aac20150300db7efe13c85b7.svg";